var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.productId
    ? _c(
        "div",
        { staticClass: "size-table" },
        [
          _c("span", { on: { click: _vm.open } }, [
            _vm._v("\n    Таблица размеров\n  ")
          ]),
          _c(
            "modal",
            { attrs: { visible: _vm.opened }, on: { "on-close": _vm.close } },
            [
              _vm.loading
                ? _c("ui-loader", { attrs: { size: "64" } })
                : _c("div", {
                    staticClass: "size-table-content",
                    domProps: { innerHTML: _vm._s(_vm.table) }
                  })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }